// extracted by mini-css-extract-plugin
export var column2 = "Columns-module--column2--34c4a";
export var column3 = "Columns-module--column3--d3946";
export var column4 = "Columns-module--column4--d7e60";
export var columnGapL = "Columns-module--columnGapL--fa051";
export var columnGapM = "Columns-module--columnGapM--69fba";
export var root = "Columns-module--root--67089";
export var rowGapM = "Columns-module--rowGapM--1eb57";
export var rowGapS = "Columns-module--rowGapS--b5e88";